<template>
  <div>
    <div class="bg-white rounded-md shadow" v-if="intervention">
      <div class="flex flex-wrap p-8 ql-editor">
        <h3 class="text-xl font-medium leading-6 text-gray-900 block pb-8 w-full">{{$t('notes')}}</h3>
        <div class="leading-relaxed pt-5" v-if="intervention.notes" v-html="intervention.notes"></div>
        <div v-else class="italic text-sm text-gray-400">{{$t('global.not_set')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import '@vueup/vue-quill/dist/vue-quill.core.css'
export default{
  props:{
    intervention: Object
  },
}
</script>
